<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<ng-container *ngIf="ready$">

  <div *ngIf="(isMSP$ | async); else notMSP" class="msps-have-no-groups">{{'groups.msps-have-no-groups' | translate}}</div>

  <ng-template #notMSP>
    <div class="container" id="manage-groups" appLifecycleTracker trackerName="manage-groups">
      <div><span class="groups-data-loaded"></span></div>
      <div class="button-bar">
        <div class="buttons">
          <button mat-raised-button color="primary" aria-label="Add Group" (click)="addButtonClick()">{{'G_ADD' | translate}}</button>
          <button mat-raised-button color="primary" aria-label="Remove Group" (click)="removeButtonClick()">{{'G_REMOVE' | translate}}</button>
        </div>
      </div>

      <div class="table-container">

        <div class="cigent-box-container">
          <strong>{{groupSummaries.data.length}} {{'APP_GROUPS' | translate}}</strong>
        </div>
        <div class="table-wrapper">

          <table mat-table [dataSource]="groupSummaries" class="mat-elevation-z0" matSortActive="name"
                 matSortDirection="asc" matSort aria-describedby="List of groups">

            <ng-container matColumnDef="select">
              <th scope="col" mat-header-cell *matHeaderCellDef class="checkbox-cell">
                <mat-checkbox (change)="toggleAll()"
                              [checked]="selection.hasValue() && isAllSelected()"
                              [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let groupSummary" class="checkbox-cell">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="toggleRow($event.checked, groupSummary)"
                              [checked]="selection.isSelected(groupSummary)"
                              [disabled]="(!!groupSummary.expires && groupSummary.expires <= now) ? 'true' : 'false'">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'groups.table-titles.name' | translate}}</th>
              <td mat-cell *matCellDef="let groupSummary">
                <span class="group-name">
                  @if (!groupSummary.expires || groupSummary.expires > now) {
                      {{groupSummary.name}}
                      @if (groupSummary.id == -1) {
                          <span class="mdi mdi-information" matTooltip="{{'ERROR_DEFAULT_GROUP' | translate}}"></span>
                      }
                  } @else {
                    <span class="expired-group">{{groupSummary.name}} ({{'EXPIRED' | translate}})</span>
                  }
                </span>
              </td>
            </ng-container>

<!--                    <ng-container matColumnDef="policy">
                      <mat-header-cell *matHeaderCellDef>{{fPolicyHeader}}</mat-header-cell>
                      <mat-cell *matCellDef="let element"> {{element.policy}} </mat-cell>
                    </ng-container>-->

            <ng-container matColumnDef="type">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'groups.table-titles.type' | translate}}</th>
              <td mat-cell *matCellDef="let groupSummary">
                <ng-container *ngIf="groupSummary.type === GroupType.device">{{'groups.types.device' | translate}}</ng-container>
                <ng-container *ngIf="groupSummary.type === GroupType.user">{{'groups.types.user' | translate}}</ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="count">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'groups.table-titles.members' | translate}}</th>
              <td mat-cell *matCellDef="let groupSummary"> {{groupSummary.count}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let groupSummary; columns: columns;" (click)="edit(groupSummary)"></tr>
          </table>
        </div>
      </div>
    </div>
  </ng-template>

</ng-container>

